export const isSellerShopApotheke = seller => seller.includes('shop-apotheke')
